/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completeLoanAmountSelection} from '../api'

export const useMutationCompleteLoanAmountSelection = createReactQueryMutationHook('completeLoanAmountSelection', completeLoanAmountSelection)
